import { render } from "./ArrangementSelector.vue?vue&type=template&id=9b4412bc&scoped=true&ts=true"
import script from "./ArrangementSelector.vue?vue&type=script&lang=ts"
export * from "./ArrangementSelector.vue?vue&type=script&lang=ts"

import "./ArrangementSelector.vue?vue&type=style&index=0&id=9b4412bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4412bc"]])

export default __exports__